import { Loader2 } from "lucide-react";

interface LoadingScreenProps {
  text?: string;
}

export function LoadingScreen({ text = "Cargando..." }: LoadingScreenProps) {
  return (
    <div className="flex min-h-[400px] items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">{text}</p>
      </div>
    </div>
  );
}
